import React from 'react';
import './ScheduleCaption.less';

export const ScheduleCaption = ({icon, text}) => {
	return (
		<div className="schedule-caption">
			{icon && <span className="schedule-caption__icon" dangerouslySetInnerHTML={{__html: icon}}></span>}
			<span className="schedule-caption__text">{text}</span>
		</div>
	);
};
